import Vue from "vue";
import VueI18n from "vue-i18n";

import ua from "@/i18n/ua.yaml";
import en from "@/i18n/en.yaml";
import pl from "@/i18n/pl.yaml";

Vue.use(VueI18n);

let messages = {};

messages = { ...messages, ua, en, pl };

const lang = localStorage.getItem("language") || "ua";

const i18n = new VueI18n({
  locale: lang,
  fallbackLocale: "ua",
  messages,
});

export default i18n;
